import * as S from './styles';

import Switch from '@components/Common/Switch';
import GridIcon from '@svgIcons/grid.svg';

import PanelOptionMixin from '../mixin';

import { CHART_TYPES } from '@/utils/consts';

const {
    COLOR_CLUSTERING,
    EMOJI_ANALYSIS,
    SCATTER,
    HORIZONTAL_BAR,
    COMBO_CHART,
    BAR,
    LINE,
} = CHART_TYPES;

const GRID_GRAPHS = [
    COLOR_CLUSTERING,
    EMOJI_ANALYSIS,
    SCATTER,
    HORIZONTAL_BAR,
    COMBO_CHART,
    BAR,
    LINE,
];

export default {
    name: 'GraphGridToggleOption',
    mixins: [PanelOptionMixin],
    props: {
        showGraphGrid: { type: Boolean, default: true },
    },
    computed: {
        hasGridOption: R.compose(
            R.includes(R.__, GRID_GRAPHS),
            R.pathOr('', ['graphOptions', 'selectedGraphType'])
        ),
    },
    render() {
        const { hasGridOption, showGraphGrid } = this;

        return (
            hasGridOption && (
                <S.ComponentWrapper>
                    <div class="top-wrapper">
                        <div class="title">
                            <GridIcon />
                            <h1>
                                {this.$t(
                                    'NEW_DASHBOARD.graph_grid_toggle_option_title'
                                )}
                            </h1>
                        </div>
                        <Switch
                            value={showGraphGrid}
                            type="big"
                            onClick={() => {
                                this.$emit('update', !showGraphGrid);
                            }}
                        />
                    </div>
                </S.ComponentWrapper>
            )
        );
    },
};
